import * as React from 'react';
import { Alert } from 'antd';
import { FlagFilled } from '@ant-design/icons';
import { useTheme } from '../../../context/theme-context';
import { getDisclaimer, getColoradoDisclaimer } from './disclaimerConstants';
import { useLocation } from 'react-router-dom';

export const Disclaimer = (): JSX.Element => {
  const theme: string = useTheme();
  const location: { pathname: string } = useLocation();

  // Dynamically determine the disclaimer based on the route
  const disclaimer: JSX.Element = location.pathname === '/colorado' ? getColoradoDisclaimer() : getDisclaimer(theme);

  return <Alert closable banner description={disclaimer} showIcon icon={<FlagFilled />} type='info' />;
};
